module.exports = __webpack_public_path__ + "media/dream_aria.6cbd6135.mp3";